"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DWGPreview = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
var FileIcon_1 = require("components/FileIcon");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var DrawingTool_1 = require("components/DrawingTool");
var enhanceDWGPreview = (0, recompose_1.compose)(recompose_1.pure);
function get_urls(revision, revisions) {
    if (revisions === void 0) { revisions = []; }
    if (revisions.length > 0) {
        return revisions.reduce(function (acc, x) {
            if (x.preview) {
                acc.push("".concat(__APIBASEURL__, "api/files/preview/?uuid[]=").concat(x.preview.uuid));
            }
            return acc;
        }, []);
    }
    if (revision.preview) {
        return [
            "".concat(__APIBASEURL__, "api/files/preview/?uuid[]=").concat(revision.preview.uuid)
        ];
    }
    return [];
}
exports.DWGPreview = enhanceDWGPreview(function (props) {
    return (React.createElement("div", { className: 'image-preview dwg' }, props.revision.preview &&
        props.revision.preview.status === 'PROCESSED' ? (React.createElement("div", { className: 'viewer-task-container overlay' },
        React.createElement(DrawingTool_1.DrawingArea, { id: props.revision.uuid, image: get_urls(props.revision, props.revisions), markings: [], addMarking: function () {
                return;
            }, onLoaded: function () {
                return;
            } }))) : (React.createElement("div", { className: 'upload-model' },
        React.createElement("div", { className: 'model-image' }, (0, FileIcon_1.typeToIconAndTextMap)('DWG').icon),
        React.createElement("div", { className: 'upload-model-content' },
            React.createElement("span", { className: 'upload-model-title' },
                React.createElement("strong", null, (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser'))),
            React.createElement(React.Fragment, null,
                !props.revision.preview ||
                    (props.revision.preview &&
                        props.revision.preview.status === 'NONE') ? (React.createElement("div", null,
                    React.createElement("span", null, (0, translation_1.getLocalization)('filesPreview/preview/dwg/pleaseExportDwgFileToSokoPro')),
                    React.createElement("span", { className: 'model-upload-button', onClick: function () {
                            props.convert(props.revision);
                        } },
                        React.createElement(Icon_1.Icon, { className: 'sok-icon-2d-pink' })))) : null,
                props.revision.preview &&
                    props.revision.preview.status === 'PROCESSING' ? (React.createElement("div", null,
                    React.createElement("span", null, (0, translation_1.getLocalization)('filesPreview/preview/dwg/waitUntilModelHasBeenExported')),
                    React.createElement("span", { className: 'model-upload-button' },
                        React.createElement(Icon_1.Icon, { className: 'sok-icon-3d-orange' })))) : null,
                props.revision.preview &&
                    props.revision.preview.status === 'FAILED' ? (React.createElement(GenericErrorMessage_1.default, { key: 'empty-folder', icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/preview/dwg/thisFileIsNotCurrentlyAvailable'))) : null))))));
});
exports.default = exports.DWGPreview;
